import { InputField, List } from '@bynder/design-system';
import styled from 'styled-components';
import { CSS_PROPERTIES } from '../../constants';
import { useState } from 'react';
import { DEFAULT_BUTTON_WIDGET_GAP } from '../../../../widgets/helpers';
import { ButtonWidget } from '../../../../../types';
import { useActiveWidget } from '../../../../../queries/guides';

const ButtonSpacing = ({
  gap,
  label,
  handleChange,
}: {
  gap: string;
  label: string;
  handleChange: (property: string, newGap: string) => void;
}) => {
  const [gapValue, setGapValue] = useState(
    gap?.split('px')[0] || String(DEFAULT_BUTTON_WIDGET_GAP),
  );
  const activeWidget = useActiveWidget() as ButtonWidget;


  const handleOnKeyDown = (value: string) => {
    setGapValue(value);
    handleChange(CSS_PROPERTIES.GAP, value + 'px');
  };

  return (
    <>
      <List.Item
        rightElements={
          <SpacingInputContainer>
            <InputField
              label=""
              isDisabled={activeWidget?.buttons?.length === 1}
              type="number"
              suffix="px"
              value={gapValue}
              onChange={handleOnKeyDown}
            />
          </SpacingInputContainer>
        }
      >
        {label}
      </List.Item>
    </>
  );
};

const SpacingInputContainer = styled.div`
  width: 100px;
`;

export default ButtonSpacing;
